import React, { useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { IoInformationCircleOutline } from 'react-icons/io5'
import { INDICATOR_INFO } from '../../utilities/dashboard'

// "i" ao lado do título: abre o que o indicador quer dizer (texto em INDICATOR_INFO). Clique, toque, Enter ou espaço abrem e
// fecham; Esc e clique fora fecham (rootClose). Abre embaixo e vira para cima quando não cabe
const InfoButton = ({ indicator }) => {
  const [show, setShow] = useState(false)
  const info = INDICATOR_INFO[indicator]
  if (!info) return null

  const id = `dashboard-info-${indicator}`

  return (
    <OverlayTrigger
      trigger='click'
      rootClose
      placement='bottom'
      flip
      show={show}
      onToggle={setShow}
      overlay={
        <Popover id={id} className='dashboard-info-popover'>
          <Popover.Header>{info.title}</Popover.Header>
          <Popover.Body>{info.text}</Popover.Body>
        </Popover>
      }
    >
      <button
        type='button'
        className='dashboard-info-button'
        aria-label='O que é este indicador'
        aria-expanded={show}
        aria-describedby={show ? id : undefined}
      >
        <IoInformationCircleOutline aria-hidden='true' />
      </button>
    </OverlayTrigger>
  )
}

// Título do cartão com o "i" logo depois da última palavra (o h3 fica só com o título). O título quebra normalmente, mas o
// "i" não desce sozinho para a linha de baixo (dashboard-infoline no style.css)
export const CardTitle = ({ title, info }) => (
  <div className='dashboard-titleline dashboard-infoline'>
    <h3 className='dashboard-card-title'>{title}</h3>
    {info ? <InfoButton indicator={info} /> : ''}
  </div>
)

export default InfoButton
